













































import InputField from "./InputField";
import Multiselect from "vue-multiselect";
import { Config } from "../../utils/Config";
import { JournalApi } from "../../api/JournalApi";

export default {
    name: "JournalFolderSelect",
    components: { InputField, Multiselect },
    props: {
        label: String,
    },
    data() {
        return {
            JournalApi: new JournalApi(),
            selected: null,
            options: [],
            vueMultiselectParams: Config.vueMultiselectParams,
            isLoading: false,
            timeout: null,
        };
    },
    created() {
        let self = this;
    },
    methods: {
        getFolders: function (value) {
            let self = this;

            self.isLoading = true;

            clearTimeout(self.timeout);
            self.timeout = setTimeout(function () {
                self.JournalApi.getAll({ limit: 50, search: value }).then(
                    function (res) {
                        self.options = res.data;
                        self.isLoading = false;
                    }
                );
            }, 500);
        },
    },
    watch: {
        selected: function () {
            this.$emit("input", this.selected);
        },
    },
};
